import { createSlice } from "@reduxjs/toolkit";
import { sanitizeCategoryData } from "../../helper/dataSanitizer";

const initialState = {
  data: null,
  globalCategories: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    addItems: (state, action) => {
      // Sanitize category data before storing in Redux
      state.data = sanitizeCategoryData(action.payload);
    },
    addGlobalCategories: (state, action) => {
      state.globalCategories = action.payload;
    },
  },
});

export const { addItems, addGlobalCategories } = categorySlice.actions;

export const categoryData = (state) => state.category.data;
export const globalCategoriesData = (state) => state.category.globalCategories;

export default categorySlice.reducer;
